import { endpoints } from 'constants/endpoints'
import type { EdiStatusOption } from 'constants/enums'
import api from 'services/api'

import {
  toEdiReprocessBatchPayloadApi,
  toEdiRequestListParamsApi,
  toEdiRequestListResponse,
  toEdiRequestLogs,
  toEdiStatusOptions,
} from './adapters'
import type {
  EdiReprocessBatchPayload,
  EdiRequestListParams,
  EdiRequestListResponse,
  EdiRequestListResponseApi,
  EdiRequestLogsResponseApi,
  EdiStatusOptionsResponseApi,
} from './interfaces'

export const fetchEdiRequestList = async (
  params: EdiRequestListParams,
): Promise<EdiRequestListResponse> => {
  const { data } = await api.get<EdiRequestListResponseApi>(endpoints.ediManagement.list, {
    params: toEdiRequestListParamsApi(params),
    paramsSerializer: { indexes: null },
  })

  return toEdiRequestListResponse(data)
}

export const postReprocessEdiOrder = async (orderNumber: string) => {
  const response = await api.post(endpoints.ediManagement.reprocess(orderNumber))

  return response
}

export const postReprocessEdiOrdersBatch = async (payload: EdiReprocessBatchPayload) => {
  const response = await api.post(
    endpoints.ediManagement.reprocessBatch,
    toEdiReprocessBatchPayloadApi(payload),
  )

  return response
}

export const fetchEdiRequestLogs = async (codigo: string): Promise<string[]> => {
  const { data } = await api.get<EdiRequestLogsResponseApi>(endpoints.ediManagement.logs(codigo))

  return toEdiRequestLogs(data.data)
}

export const fetchEdiStatusOptions = async (): Promise<EdiStatusOption[]> => {
  const { data } = await api.get<EdiStatusOptionsResponseApi>(endpoints.ediManagement.status)

  return toEdiStatusOptions(data)
}
